module.exports = __webpack_public_path__ + "img/laboOrange.edc3782c.svg";